module.exports = __webpack_public_path__ + "static/img/marcus_pictgrid50_1080x816.644a2fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/marcus_pictgrid50_1080x816.jpg
// module id = hSoW
// module chunks = 0